import imageCompression from 'browser-image-compression'

/**
 * Procesa una imagen capturada/seleccionada antes de subirla al backend (REP-05 §2.5 SRS):
 *   - Reescala al lado mayor = 1080 px máximo.
 *   - Convierte a WebP quality 0.85 (browser-image-compression lo soporta nativamente).
 *   - Conserva el File API para que multipart funcione igual.
 *
 * Si el archivo ya es <= 1080px y < ~500KB, la librería puede no recomprimir y devolver
 * el original. Eso es OK.
 *
 * En caso de error (formato no soportado, browser sin canvas), devuelve el original
 * para no bloquear el flujo — el backend re-valida MIME y tamaño.
 */
/**
 * Comprime una imagen de logo o firma antes de subirla al backend.
 * Reescala al lado mayor = 1920 px máximo y aplica el límite de tamaño indicado.
 * Si la compresión falla, devuelve el original.
 */
export async function compressUploadImage(file: File, maxMB: number): Promise<File> {
  try {
    const compressed = await imageCompression(file, {
      maxSizeMB: maxMB,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    })
    return new File([compressed], file.name, { type: compressed.type })
  } catch (err) {
    console.warn('Compresión de imagen falló, usando original:', err)
    return file
  }
}

export async function processReportImage(file: File): Promise<File> {
  try {
    const compressed = await imageCompression(file, {
      maxSizeMB: 2,            // 2 MB max tras reescalado
      maxWidthOrHeight: 1080,  // §2.5 SRS
      useWebWorker: true,
      fileType: 'image/webp',
      initialQuality: 0.85,
    })
    // browser-image-compression devuelve un Blob; lo envolvemos en File para preservar nombre.
    const filename = replaceExtension(file.name || 'imagen.webp', 'webp')
    return new File([compressed], filename, { type: 'image/webp' })
  } catch (err) {
    console.warn('Reescalado falló, subiendo original:', err)
    return file
  }
}

function replaceExtension(name: string, newExt: string): string {
  const dot = name.lastIndexOf('.')
  if (dot < 0) return `${name}.${newExt}`
  return `${name.substring(0, dot)}.${newExt}`
}
